export const externalShippingTracker = (state) =>
  state.order.externalShippingTracker;
export const messages = (state) => state.order.messages;
